<div class="row">
  <div class="cx-info col-12">
    <p class="cx-promotion-name"></p> <!--Include promotions here-->
  </div>
  <!-- Item Image -->
  @if (cartEntry?.product?.images?.length) {
    <div class="cx-image-container col-12">
      <a [routerLink]="{ cxRoute: 'product', params: cartEntry.product } | cxUrl" tabindex="-1">
        <cx-media [container]="cartEntry.product.images[0]" format="product"></cx-media>
      </a>
    </div>
  }
  <!-- Item Information -->
  <div class="cx-info col-12">
    <div class="cx-info-container row">
      <!-- Item Description -->
      <div class="col-12 mb-3">
        <div class="cx-manufacturer font-weight-bold d-block mb-2">
          {{ cartEntry.product.manufacturer }}
        </div>
        @if (cartEntry.product.name) {
          <div class="cx-name d-block">
            <a class="cx-link" [routerLink]=" { cxRoute: 'product', params: cartEntry.product } | cxUrl">
              {{ cartEntry.product.name }}
            </a>
          </div>
        }

        <div class="cx-code d-block">
          @if (cartEntry.product.averageRating) {
            <cx-star-rating
            [rating]="cartEntry.product.averageRating"></cx-star-rating>
          }
        </div>

        <!-- Variants -->
        @if (cartEntry.product.baseOptions?.length) {
          @for ( variant of cartEntry.product.baseOptions[0]?.selected ?.variantOptionQualifiers; track  variant) {
            <div
              class="cx-property">
              @if (variant.name && variant.value) {
                <div class="cx-label">
                  {{ variant.name }}: {{ variant.value }}
                </div>
              }
            </div>
          }
        }
      </div>
      <!-- Total -->
      <div class="col-12">
        <!--            Item Price-->
        @if (cartEntry.product?.price?.formattedValue) {
          <div class="cx-price">
            {{ cartEntry.product.price.formattedValue }}
            @if (cartEntry.product?.price?.discountValue) {
              <span class="old-price">{{ cartEntry.product?.price?.originalPrice.formattedValue}}</span>
              <span class="discount">{{ cartEntry.product?.price?.discountPercentage }}</span>
            }
          </div>
        }
      </div>
    </div>
  </div>
  <div class="cx-add-to-cart">
    @if (cartEntry.product?.stock?.notifiable) {
      <app-custom-stock-notification [product]="cartEntry.product"></app-custom-stock-notification>
    } @else {
      @if (cartEntry.product.stock?.stockLevelStatus !== 'outOfStock') {
        <cx-add-to-cart [pdp]="false"
          [showQuantity]="false"
          [product]="cartEntry.product"
        ></cx-add-to-cart>
      }
    }
  </div>
</div>

